<template lang="pug"></template>

<script>
export default {
    name: 'ContainerInformacoes'
};
</script>

<style lang="scss" scoped>
.dados-gerais {
    @include border-radius($default-border-radius);
    border: 1px solid var(--default-border-color);
    background-color: var(--white);
    width: 100%;
    height: 81px;
    display: flex;
    justify-content: space-between;
    padding: 20px;

    // @extend .default-shadow;
    @include default-box-shadow();
}
</style>
